/**
 * PageContext — Shares page metadata and Caleb chat open requests between
 * deeply nested components and the AppHeader.
 */

import React, { createContext, useContext, useState, useCallback } from 'react';

const PageContext = createContext({
  pageTitle: null,
  setPageTitle: () => {},
  calebChatRequest: 0,
  openCalebChat: () => {},
});

export const PageProvider = ({ children }) => {
  const [pageTitle, setPageTitleRaw] = useState(null);
  const [calebChatRequest, setCalebChatRequest] = useState(0);

  const setPageTitle = useCallback((title) => {
    setPageTitleRaw(title);
  }, []);
  const openCalebChat = useCallback(() => {
    setCalebChatRequest((request) => request + 1);
  }, []);

  return (
    <PageContext.Provider value={{
      pageTitle, setPageTitle, calebChatRequest, openCalebChat,
    }}>
      {children}
    </PageContext.Provider>
  );
};

export const usePageContext = () => useContext(PageContext);

export default PageContext;
